export default __webpack_public_path__ + "static/media/Deed of Contract_06.10b84058.jpg";